import { AuthService } from 'app/services/auth';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { URLSearchParams, ResponseContentType } from '@angular/http';
import { EventsService } from 'app/services/events';

@Injectable()
export class AjaxService {
    // private baseUrl: string = 'https://ws1.paranamodapark.com.br:65435';
    private baseUrl = 'https://pmp.rlimainfo.com.br:65438';
    // private baseUrl: string = 'http://10.101.0.99:65438';
    private headersBasic: any;
    private evento: any;

    constructor(
        private http: AuthHttp,
        private httpComum: Http,
        private auth: AuthService,
        private events: EventsService,
    ) {
        this.headersBasic = new Headers();
        this.headersBasic.append('Cache-Control', 'no-cache');
        this.headersBasic.append('Accept', 'application/json');
        this.headersBasic.append('Content-Type', 'application/json');
        // tslint:disable-next-line:prefer-template
        this.headersBasic.append('Authorization', 'Basic ' + this.auth.getCode());
        this.evento = events.getEvento();
    }

    getUrl(): string {
        return this.baseUrl;
    }

    post(url, dados, disableLoader?): Promise<any> {
        if (!disableLoader) {
            this.evento.emit({ tipo: 'loader:show' });
        }
        return this.http.post(this.baseUrl + url, JSON.stringify(dados)).catch((error) => {
            return this.auth.refreshToken().concatMap((resposta) => {
                return this.http.post(this.baseUrl + url, JSON.stringify(dados));
            });
        }).timeout(120000).map((data) => {
            if (!disableLoader) {
                this.evento.emit({ tipo: 'loader:hide' });
            }
            return data.json();
        }).catch((error) => {
            if (!disableLoader) {
                this.evento.emit({ tipo: 'loader:hide' });
            }
            throw error;
        }).toPromise();
    }

    postBasic(url, dados): Promise<any> {
        this.evento.emit({ tipo: 'loader:show' });
        return this.httpComum.post(this.baseUrl + url, dados, {
            headers: this.headersBasic,
        }).timeout(120000).map((data) => {
            this.evento.emit({ tipo: 'loader:hide' });
            return data.json();
        }).catch((error) => {
            this.evento.emit({ tipo: 'loader:hide' });
            throw error;
        }).toPromise();
    }

    get(url, query?, disableLoader?): Promise<any> {
        const params = new URLSearchParams();
        if (query) {
            for (const parametro in query) {
                if (query.hasOwnProperty(parametro)) {
                    params.set(parametro, query[parametro]);
                }
            }
        }
        if (!disableLoader) {
            this.evento.emit({ tipo: 'loader:show' });
        }
        return this.http.get(this.baseUrl + url, { search: params }).catch((error) => {
            return this.auth.refreshToken().concatMap((resposta) => {
                return this.http.get(this.baseUrl + url, { search: params });
            });
        }).timeout(120000).map((data) => {
            if (!disableLoader) {
                this.evento.emit({ tipo: 'loader:hide' });
            }
            return data.json();
        }).catch((error) => {
            if (!disableLoader) {
                this.evento.emit({ tipo: 'loader:hide' });
            }
            throw error;
        }).toPromise();
    }

    getBasic(url, query?): Promise<any> {
        const params = new URLSearchParams();
        if (query) {
            for (const parametro in query) {
                if (query.hasOwnProperty(parametro)) {
                    params.set(parametro, query[parametro]);
                }
            }
        }
        this.evento.emit({ tipo: 'loader:show' });
        return this.httpComum.get(this.baseUrl + url, {
            headers: this.headersBasic,
            search: params,
        }).timeout(120000).map((data) => {
            this.evento.emit({ tipo: 'loader:hide' });
            return data.json();
        }).catch((error) => {
            this.evento.emit({ tipo: 'loader:hide' });
            throw error;
        }).toPromise();
    }

    getStream(url, query?): Promise<any> {
        const headers = new Headers();
        headers.append('Accept', '*/*');

        const params = new URLSearchParams();
        if (query) {
            for (const parametro in query) {
                if (query.hasOwnProperty(parametro)) {
                    params.set(parametro, query[parametro]);
                }
            }
        }
        this.evento.emit({ tipo: 'loader:show' });
        return this.http.get(this.baseUrl + url,
            {
                search: params,
                headers,
                responseType: ResponseContentType.Blob,
            }).catch((error) => {
                return this.auth.refreshToken().flatMap((resposta) => {
                    return this.http.get(this.baseUrl + url, { search: params });
                });
            }).timeout(1200000).map((data) => {
                this.evento.emit({ tipo: 'loader:hide' });
                return data.blob();
            }).catch((error) => {
                this.evento.emit({ tipo: 'loader:hide' });
                throw error;
            }).toPromise();
    }

    put(url, dados, disableLoader?): Promise<any> {
        if (!disableLoader) {
            this.evento.emit({ tipo: 'loader:show' });
        }
        return this.http.put(this.baseUrl + url, dados).catch((error) => {
            return this.auth.refreshToken().concatMap((resposta) => {
                return this.http.put(this.baseUrl + url, dados);
            });
        }).timeout(120000).map((data) => {
            if (!disableLoader) {
                this.evento.emit({ tipo: 'loader:hide' });
            }
            return data.json();
        }).catch((error) => {
            if (!disableLoader) {
                this.evento.emit({ tipo: 'loader:hide' });
            }
            throw error;
        }).toPromise();
    }

    putBasic(url, dados): Promise<any> {
        this.evento.emit({ tipo: 'loader:show' });
        return this.httpComum.put(this.baseUrl + url, dados, {
            headers: this.headersBasic,
        }).timeout(120000).map((data) => {
            this.evento.emit({ tipo: 'loader:hide' });
            return data.json();
        }).catch((error) => {
            this.evento.emit({ tipo: 'loader:hide' });
            throw error;
        }).toPromise();
    }

    delete(url, id): Promise<any> {
        this.evento.emit({ tipo: 'loader:show' });
        // tslint:disable-next-line:prefer-template
        return this.http.delete(this.baseUrl + url + '/' + id).catch((error) => {
            return this.auth.refreshToken().concatMap((resposta) => {
                // tslint:disable-next-line:prefer-template
                return this.http.delete(this.baseUrl + url + '/' + id);
            });
        }).timeout(120000).map((data) => {
            this.evento.emit({ tipo: 'loader:hide' });
            return data.json();
        }).catch((error) => {
            this.evento.emit({ tipo: 'loader:hide' });
            throw error;
        }).toPromise();
    }
}



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/services/ajax/ajax.service.ts